(function (angular) {
    'use strict';

    angular.module('integration')
        /**
         *
         */
        .controller('webhookFailuresCtrl',
            ['$scope', '$stateParams', '$uibModal', 'failureData',
                function ($scope, $stateParams, $uibModal, failureData) {

                    $scope.failures = failureData;

                    $scope.webhookId = $stateParams.webhookId;

                    $scope.launchFailureDetailsModal = function (failureObject) {
                        var modalInstance = $uibModal.open({
                            templateUrl: 'components/platformConfiguration/integration/templates/failureDetailsModal.html',
                            size: 'md',
                            controller: 'failureDetailsModal',
                            resolve: {
                                failure: function() {
                                    return failureObject;
                                }
                            }
                        });
                    }
            }])

        .controller('failureDetailsModal',
             ['$scope', 'failure', '$uibModalInstance', '$timeout',
                function ($scope, failure, $uibModalInstance, $timeout) {

                    $timeout(function () {
                        var cm = angular.element(document.querySelectorAll('.CodeMirror'));
                        for (const element of cm) {
                            element.CodeMirror.refresh();
                        }
                    }, 0);

                    $scope.lastAttempt = failure.lastAttempt;
                    $scope.created = failure.created;
                    $scope.retry = failure.retry;
                    $scope.status = failure.status;
                    $scope.statusText = failure.statusText;
                    $scope.uri = failure.uri;
                    $scope.timeout = failure.timeout;
                    $scope.request = JSON.stringify(JSON.parse(failure.request), null, 4);
                    $scope.responseBody = failure.responseBody;
                    $scope.contentType = failure.contentType;

                    $scope.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };

                    $scope.editorOptions = {
                        lineWrapping: false,
                        lineNumbers: true,
                        autofocus: true,
                        readyOnly: "nocursor",
                        theme: "panda-syntax",
                        mode: "application/json"
                    };
            }])

})(window.angular);
